import React, { useState } from "react";
import "./OutOfHomeFAQ.css";
import { useTranslation } from "react-i18next";
import { FaChevronDown } from "react-icons/fa";

const OutOfHomeFAQ = () => {
  const { t } = useTranslation();
  const items = t("outOfHomePage.faq.items", { returnObjects: true });
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <div className="oohs-section">
      <div className="oohs-section-inner ooh-faq-inner">
        <div className="ooh-faq-layout">
          <h2 className="ooh-faq-title">{t("outOfHomePage.faq.title")}</h2>

          <div className="ooh-faq-list">
            {items.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={index} className={`ooh-faq-item ${isOpen ? "open" : ""}`}>
                  <button
                    type="button"
                    className="ooh-faq-question"
                    onClick={() => toggle(index)}
                    aria-expanded={isOpen}
                  >
                    <span>{item.q}</span>
                    <FaChevronDown className="ooh-faq-icon" size={14} />
                  </button>
                  <div className="ooh-faq-answer-wrap">
                    <p
                      className="ooh-faq-answer"
                      dangerouslySetInnerHTML={{ __html: item.a }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutOfHomeFAQ;
